export default function logout() {
  document.getElementById("hidden-logout-form").submit()
}
